// extracted by mini-css-extract-plugin
module.exports = {"content":"SimpleGuide_style_content__2FY_r"};